import script from "./HomeTestimonialsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeTestimonialsComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeTestimonialsComponent.vue?vue&type=style&index=0&id=88e9c62c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88e9c62c"]])

export default __exports__